export default "__VITE_ASSET__617f3608__"